import "./school.css";

// Entwurf der Datenschutzhinweise zur Registrierung (Meilenstein M45). Vor dem ersten echten Einsatz prüfen lassen.
export function PrivacyNotice(props: { onBack: () => void }) {
  return (
    <div class="auth-container">
      <div class="deco-blob auth-blob-1" /><div class="deco-blob auth-blob-2" /><div class="deco-blob auth-blob-3" />
      <div class="auth-hero"><img class="auth-hero-logo" src="/img/reflexo-logo.png" alt="Reflexo" /></div>
      <article class="auth-card sr-card-wide fade-in sr-legal">
        <h1 class="sr-title">Datenschutzhinweise zur Registrierung einer Schule</h1>
        <p class="sr-sub">Stand: 25. Oktober 2026</p>
        <h2>Wer ist verantwortlich?</h2>
        <p>Reflexo UG (haftungsbeschränkt). Die Anschrift steht im Impressum auf reflexo.info. Kontakt: mail@reflexo.info.</p>
        <h2>Welche Daten wir erfassen</h2>
        <ul>
          <li>Angaben zur Schule: Name, Anschrift, Schulform, Schulnummer (freiwillig), geschätzte Klassenzahl (freiwillig).</li>
          <li>Angaben zur Ansprechperson: Vorname, Nachname, Funktion, dienstliche E-Mail-Adresse.</li>
          <li>Technisch: Zeitpunkt Ihrer Bestätigung und eine nicht umkehrbare Prüfsumme (Hash) Ihrer IP-Adresse, um Missbrauch zu erkennen.</li>
        </ul>
        <h2>Wozu</h2>
        <p>Wir prüfen Ihre Anfrage, richten den Testzugang ein, schließen mit Ihnen den Auftragsverarbeitungsvertrag und schreiben Ihnen in diesem Zusammenhang E-Mails. Die Prüfung durch uns dient auch dem Schutz vor Missbrauch.</p>
        <h2>Rechtsgrundlage</h2>
        <p>Maßnahmen vor Abschluss eines Vertrags auf Ihre Anfrage (Art. 6 Abs. 1 lit. b DSGVO) und unser berechtigtes Interesse am Schutz vor Missbrauch (Art. 6 Abs. 1 lit. f DSGVO).</p>
        <h2>Wie lange wir die Daten speichern</h2>
        <p>Anfragen, die nicht bestätigt, nicht freigegeben, abgelehnt oder nicht abgeschlossen werden, löschen wir nach 30 Tagen. Kommt es zum Vertrag, gelten dessen Fristen.</p>
        <h2>An wen wir Daten weitergeben</h2>
        <p>Nur an Dienstleister, die in unserem Auftrag arbeiten: das Hosting des Servers und den Versand der E-Mails. Mit ihnen bestehen Verträge zur Auftragsverarbeitung.</p>
        <h2>Ihre Rechte</h2>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung und Widerspruch sowie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren. Schreiben Sie uns dazu an mail@reflexo.info.</p>
        <p style={{ "margin-top": "18px" }}><button class="btn btn-full" type="button" onClick={props.onBack}>Zurück</button></p>
      </article>
    </div>
  );
}
